export default {
  rowSelection: true,
  fieldControl: false,
  rowSelectionType: 'radio',
  scroll: {y: 350},
  columns: [
    {
      title: '酷家乐账号',
      dataIndex: 'kjlAccount',
      width: 180,
      fixed: 'left',
    },
    {
      title: '酷家乐账号名称',
      dataIndex: 'kjlName',
      width: 180,
    },
    {
      title: '关联生活家账号',
      dataIndex: 'appuid',
      width: 160,
    },
    {
      title: '使用分公司',
      dataIndex: 'companyName',
      width: 160,
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 200,
    },
    {
      title: '最后修改人',
      dataIndex: 'modifiedByName',
      width: 120,
    },
    {
      title: '最后修改时间',
      dataIndex: 'lastUpdatedTime',
      width: 160,
      itemType: 'dateTime'
    },
  ],
  search: [
    {
      name: 'kjlAccount',
      label: '酷家乐账号',
      itemType: 'input',
    },
    {
      name: 'kjlName',
      label: '酷家乐账号名称',
      itemType: 'input',
    },
    {
      name: 'companyCode',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companies',
      addonOpts: [],
      showSearch: true,
      filterOption: (input: any, option: any) =>
        (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase()),
    },
  ],
  footer: [],
};
